"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Range = exports.RANGE_VALUE_TYPE = void 0;
Object.defineProperty(exports, "STYLE_TYPE", {
  enumerable: true,
  get: function () {
    return _common.STYLE_TYPE;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _common = require("b2b-components/theme/components/Form/common");
var _TextInput = require("b2b-components/theme/components/Form/TextInput");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Range.scss");
var RANGE_VALUE_TYPE = exports.RANGE_VALUE_TYPE = /*#__PURE__*/function (RANGE_VALUE_TYPE) {
  RANGE_VALUE_TYPE["max"] = "max";
  RANGE_VALUE_TYPE["min"] = "min";
  return RANGE_VALUE_TYPE;
}(RANGE_VALUE_TYPE || {});
const Range = _ref => {
  let {
    rangesIds,
    buttonLabel,
    className,
    onChange,
    onInputBlur,
    onInputChange,
    isDisabled = false,
    // todo should be just disabled
    maxValue = '',
    minValue = '',
    styleType = _common.STYLE_TYPE.outlined,
    text = {
      minPlaceholder: 'from',
      maxPlaceholder: 'to'
    },
    dataAttributes
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Range', className);
  const buttonClassName = (0, _classnames.default)('cds-Range-Button', {
    'cds-Range-Button--Outlined': styleType === _common.STYLE_TYPE.outlined && (text.minLabel || text.maxLabel)
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Range-Input"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    textInputId: rangesIds.minId,
    error: text.minError,
    disabled: isDisabled,
    onBlur: value => onInputBlur(value, RANGE_VALUE_TYPE.min),
    onChange: value => onInputChange(value, RANGE_VALUE_TYPE.min),
    styleType: styleType,
    text: {
      label: text.minLabel,
      placeholder: text.minPlaceholder
    },
    type: _TextInput.TEXT_INPUT_TYPE.number,
    value: minValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Range-Input"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    textInputId: rangesIds.maxId,
    error: text.maxError,
    disabled: isDisabled,
    onBlur: value => onInputBlur(value, RANGE_VALUE_TYPE.max),
    onChange: value => onInputChange(value, RANGE_VALUE_TYPE.max),
    styleType: styleType,
    value: maxValue,
    text: {
      label: text.maxLabel,
      placeholder: text.maxPlaceholder
    },
    type: _TextInput.TEXT_INPUT_TYPE.number
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: buttonClassName,
    isDisabled: isDisabled,
    onClick: onChange,
    size: _Button.BUTTON_SIZE.small
  }, buttonLabel));
};
exports.Range = Range;
//# sourceMappingURL=Range.js.map